module.exports = __webpack_public_path__ + "img/p16.4de01a25.png";